module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [(_vm.viewType == _vm.VIEW_LIST) ? _c('div', {
    attrs: {
      "id": _vm.VIEW_LIST
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "col-sm-1 col-md-1 col-lg-1",
    staticStyle: {
      "margin-top": "10px",
      "text-align": "left"
    },
    attrs: {
      "for": "recordPerPage"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-md-2 col-lg-1",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('select', {
    ref: "recordPerPage",
    staticClass: "form-control",
    on: {
      "change": _vm.changePageSize
    }
  }, [(_vm.inquiryParam.pageSize == 5) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("5")]) : _c('option', [_vm._v("5")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 10) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("10")]) : _c('option', [_vm._v("10")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 20) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("20")]) : _c('option', [_vm._v("20")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 50) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("50")]) : _c('option', [_vm._v("50")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 100) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("100")]) : _c('option', [_vm._v("100")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.inquiry
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.listData), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticStyle: {
        "width": "45px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSequence + i + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "nowrap": ""
      }
    }, [_c('a', {
      ref: "displayRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplay(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-search",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "editRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onEdit(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Edit"
      }
    })]), _vm._v(" "), _c('a', {
      ref: "deleteRow",
      refInFor: true,
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDelete(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onAssign(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-check-square-o",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Assign Location"
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDisplayQRCode(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-qrcode",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Display QRCode"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.projectName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.usedBy))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.clientHubId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.projectId))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind",
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber - 1)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("\n                  Page\n              ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiryParam.CurrentPageNumber),
      expression: "inquiryParam.CurrentPageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "margin-left": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "id": "CurrentPage"
    },
    domProps: {
      "value": (_vm.inquiryParam.CurrentPageNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.gotoPage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inquiryParam, "CurrentPageNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "TotalPageText"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.totalPages) + "                \n              ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-right-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber + 1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-fastforward",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.totalPages)
      }
    }
  })])])])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewType == _vm.VIEW_FORM) ? _c('div', {
    attrs: {
      "id": _vm.VIEW_FORM
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Location Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', {
    attrs: {
      "for": "inputProject"
    }
  }, [_vm._v("Project")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.projectId),
      expression: "formData.projectId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formData, "projectId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listProjectForm), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                        " + _vm._s(row.name) + "\n                      ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "inputStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.status),
      expression: "formData.status"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "inputStatus",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "status", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "inputUsedBy"
    }
  }, [_vm._v("Used By")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.usedBy),
      expression: "formData.usedBy"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "inputUsedBy",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.usedBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "usedBy", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "inputClientHubID"
    }
  }, [_vm._v("Client Hub ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.clientHubId),
      expression: "formData.clientHubId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "inputClientHubID",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formData.clientHubId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "clientHubId", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.projectId),
      expression: "formData.projectId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputProjectId"
    },
    domProps: {
      "value": (_vm.formData.projectId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "projectId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEdit(_vm.formData)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "45px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Project")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Used By")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("ClientHub ID")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-dialog-qris",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-qris"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("QR Passcode")])]), _vm._v(" "), _c('div', {
    staticClass: "qris",
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "message"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-928ce4e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CheckInOutLocation.vue
// module id = 767
// module chunks = 1